module.exports = __webpack_public_path__ + "static/media/hunterdonlogo.e2bc92c3.jpg";